module.exports = __webpack_public_path__ + "assets/images/ending4_fbfb60b205e2467a3b718e6567e4d066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending4.png
// module id = 136
// module chunks = 0